import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ColumnIcon from 'vue-material-design-icons/ViewColumn.vue';
import DataTableColumn from './dataTableColumn';
import MultiSelectPicker from '@/shared/components/MultiSelectPicker.vue';
import { PropType } from 'vue';
import { useVModel } from '@vueuse/core';


export default /*@__PURE__*/_defineComponent({
  __name: 'ColumnPicker',
  props: {
  columns: {
    type: Array as PropType<DataTableColumn[]>,
    required: true,
  },
  modelValue: {
    type: Array as PropType<DataTableColumn[]>,
    default: [],
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const value = useVModel(props, 'modelValue', emit);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MultiSelectPicker, {
    modelValue: _unref(value),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
    options: __props.columns,
    "id-attribute": "name",
    "display-attribute": "display",
    tooltip: "Show/Hide columns"
  }, {
    "button-display": _withCtx(() => [
      _createVNode(ColumnIcon, { class: "icon-1-5x" })
    ]),
    _: 1
  }, 8, ["modelValue", "options"]))
}
}

})